function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { string } from "prop-types";
import { ThemeProvider } from "./ThemeManagement";
import { ElementMessageLayout } from "./Layout/ElementMessageLayout";
import { ELEMENT_MESSAGE_TYPES as TYPES, ELEMENT_MESSAGE_THEMES as THEMES } from "./misc/constants";
export var ElementMessage = function ElementMessage(props) {
  var theme = props.theme,
    type = props.type;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    initialValue: {
      theme: theme,
      type: type
    }
  }, /*#__PURE__*/React.createElement(ElementMessageLayout, props));
};
ElementMessage.defaultProps = {
  theme: THEMES.MESSAGE,
  type: TYPES.REGULAR
};
ElementMessage.propTypes = {
  theme: string,
  type: string
};
export var buildThemedElementMessage = function buildThemedElementMessage() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THEMES.MESSAGE;
  // eslint-disable-next-line react/no-multi-comp
  return function (props) {
    return /*#__PURE__*/React.createElement(ElementMessage, _extends({}, props, {
      theme: theme
    }));
  };
};
var themedElementMessage = buildThemedElementMessage();
ElementMessage.Note = function (props) {
  return themedElementMessage(_objectSpread(_objectSpread({}, props), {}, {
    type: TYPES.NOTE
  }));
};
/* We force the name for test purposes to recognize the component as Notification and not Anonymous */
ElementMessage.Note.displayName = "ElementMessage";
ElementMessage.Tips = function (props) {
  return themedElementMessage(_objectSpread(_objectSpread({}, props), {}, {
    type: TYPES.TIPS
  }));
};
ElementMessage.Tips.displayName = "ElementMessage";
ElementMessage.Warning = function (props) {
  return themedElementMessage(_objectSpread(_objectSpread({}, props), {}, {
    type: TYPES.WARNING
  }));
};
ElementMessage.Warning.displayName = "ElementMessage";
ElementMessage.Error = function (props) {
  return themedElementMessage(_objectSpread(_objectSpread({}, props), {}, {
    type: TYPES.ERROR
  }));
};
ElementMessage.Error.displayName = "ElementMessage";